import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormGroup,
  FormArray,
  FormControl,
  Form,
  FormBuilder,
  Validators,
  FormsModule,
} from "@angular/forms";

import { ResponseApi } from "./response-api";
import { LoginService } from "../login.service";
import { SharedService } from "../shared.service";
import { apiUrl } from "../global";

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP =
    /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value)
    ? null
    : {
        validateEmail: {
          valid: false,
        },
      };
}

@Component({
  selector: "login",
  templateUrl: "login.component.html",
  styleUrls: ["login.component.css"],
})
export class LoginComponent implements OnInit {
  responseApis: ResponseApi[];
  loginAttempt: any;
  error: any;
  backgroundColor: string;
  fadeOutLoader: boolean;
  fadeOutLoaderLogin: boolean;
  logo: any;
  domainList: any;
  userListType: boolean;
  hasUserList: boolean;
  form: any;
  attemptToSubmit: boolean;
  showLoaderLogin: boolean;
  textError: string;
  identifierForServer: string;
  fadeInConnexion: boolean;
  baseUrl: any;
  myGlobals: any;
  emailToSend: any;
  nocibe: boolean;
  phoneRegie: boolean;
  ucanss: boolean;
  demo: boolean;
  levi: boolean;
  moet: boolean;
  nexter: boolean;
  hein: boolean;
  oeth: boolean;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private sharedService: SharedService
  ) {
    this.baseUrl = apiUrl;
    this.myGlobals = apiUrl;
    this.attemptToSubmit = true;

    this.fadeOutLoaderLogin = false;
    this.showLoaderLogin = false;

    this.textError = "";
    this.fadeInConnexion = false;
  }
  setBackgroundColor(backgroundColor: string): void {
    this.sharedService.setBackgroundColor(backgroundColor);
  }
  getBackgroundColor() {
    return this.sharedService.getVal("backgroundColor");
  }
  getUrl(url: string): void {
    this.loginService
      .getUrl(url)
      .then((responseApi) => {
        this.responseApis = responseApi;
        if (this.responseApis["success"] == false) {
          this.router.navigate(["page-not-found"]);
        } else {
          var domain =
            this.responseApis[0]["data"]["generalDetails"][0]["has_domain"];
          var userListType =
            this.responseApis[0]["data"]["generalDetails"][0]["user_list_type"];
          var hasUserList =
            this.responseApis[0]["data"]["generalDetails"][0]["has_user_list"];

          if (domain == 1) {
            this.domainList = this.responseApis[0]["data"]["domains"];
          } else {
            this.domainList = false;
          }

          if (userListType == "email") {
            this.userListType = true;
          } else {
            this.userListType = false;
          }

          if (hasUserList == 1) {
            this.hasUserList = true;
          } else {
            this.hasUserList = false;
          }

          //has list - email
          if (this.hasUserList && this.userListType) {
            this.form = new FormGroup({
              name: new FormControl("", Validators.required),
              lastName: new FormControl("", Validators.required),
              privacyAgreement: new FormControl("", Validators.required),
              email: new FormControl("", validateEmail),
            });
          } else if (this.hein) {
            this.form = new FormGroup({
              name: new FormControl("", Validators.required),
              lastName: new FormControl("", Validators.required),
              privacyAgreement: new FormControl("", Validators.required),
              email: new FormControl("", validateEmail),
            });
          }

          //has list - no email, email not mandatory
          else if (this.hasUserList && !this.userListType) {
            this.form = new FormGroup({
              name: new FormControl("", Validators.required),
              lastName: new FormControl("", Validators.required),
              identifier: new FormControl("", Validators.required),
              privacyAgreement: new FormControl("", Validators.required),
              email: new FormControl("", validateEmail),
            });
          }

          // no list has a list of domains
          else if (
            !this.hasUserList &&
            this.userListType &&
            this.domainList != false
          ) {
            console.log(this.domainList[0]);
            if (this.ucanss || this.demo || this.levi) {
              this.form = new FormGroup({
                name: new FormControl("", Validators.required),
                lastName: new FormControl("", Validators.required),
                identifier: new FormControl("", Validators.nullValidator),
                privacyAgreement: new FormControl("", Validators.required),
                email: new FormControl(this.domainList[0].domain),
              });
            } else {
              console.log(121212902390);
              this.form = new FormGroup({
                name: new FormControl("", Validators.required),
                lastName: new FormControl("", Validators.required),
                identifier: new FormControl("", Validators.required),
                privacyAgreement: new FormControl("", Validators.required),
                email: new FormControl(this.domainList[0].domain),
              });
            }
          }

          //No list of users, no registered domains, no identifiers
          else if (!this.hasUserList && !this.domainList) {
            this.form = new FormGroup({
              name: new FormControl("", Validators.required),
              lastName: new FormControl("", Validators.required),
              privacyAgreement: new FormControl("", Validators.required),
              //email: new FormControl('', validateEmail)
            });
          } else {
            this.router.navigate(["page-not-found"]);
          }

          this.setBackgroundColor(
            this.responseApis[0]["data"]["generalDetails"][0][
              "background_color"
            ]
          );
          console.log(this.getBackgroundColor());
          this.backgroundColor =
            this.responseApis[0]["data"]["generalDetails"][0][
              "background_color"
            ];
          var m = this;
          setTimeout(function () {
            m.fadeOutLoader = true;
            m.logo = apiUrl + m.responseApis[0]["data"]["logo"][0]["path"];
          }, 2000);
        }
      })
      .catch((error) => (this.error = error));
  }

  postAuthenticate(
    url: string,
    firstName: string,
    lastName: string,
    identifier: string,
    email: string
  ): void {
    this.loginService
      .postAuthenticate(url, firstName, lastName, identifier, email)
      .then((responseApi) => {
        this.loginAttempt = responseApi;
        var thing = this;
        this.fadeOutLoaderLogin = true;
        console.log(thing.loginAttempt);
        setTimeout(function () {
          thing.fadeOutLoaderLogin = false;
          thing.showLoaderLogin = false;
          thing.textError = thing.loginAttempt["msg"];
          if (
            thing.textError ==
            "Utilisateur déjà inscrit. Sélectionnez l'onglet Connexion."
          ) {
            thing.fadeInConnexion = true;
          } else {
            if (
              thing.route.params["_value"].url == "monoprix" ||
              thing.route.params["_value"].url == "strego" ||
              thing.route.params["_value"].url == "aetd" ||
              thing.route.params["_value"].url == "oratio" ||
              thing.route.params["_value"].url == "jti"
            ) {
              //console.log(thing.loginAttempt['data'][0].hash);
              console.log("========");
              var urlToNav = thing.route.params["_value"].url;
              thing.router.navigate([
                "/validate-email/" +
                  urlToNav +
                  "/" +
                  thing.loginAttempt["data"][0].hash,
              ]);
              //console.log(thing.loginAttempt.hash)
            }
            this.fadeInConnexion = false;
          }

          if (thing.loginAttempt) {
            if (thing.loginAttempt.msg == "User validated") {
              console.log(thing.loginAttempt.data[0]["email"]);
              console.log([
                thing.route.params["_value"].url +
                  "/login/" +
                  thing.loginAttempt.data[0]["email"],
              ]);
              thing.router.navigate([
                thing.route.params["_value"].url +
                  "/login/" +
                  thing.loginAttempt.data[0]["email"],
              ]);
            }
          }
        }, 1000);
      })
      .catch((error) => (this.error = error));
  }

  loginUser() {
    console.log(this.form);
    if (
      !this.form.valid ||
      this.form["_value"]["privacyAgreement"] == "" ||
      this.form["_value"]["privacyAgreement"] == false
    ) {
      console.log(44444444555);
      this.attemptToSubmit = false;
    } else {
      this.attemptToSubmit = true;
      var formValues = this.form.value;
      if (typeof formValues.identifier == "undefined") {
        console.log(4444444);
        this.identifierForServer = formValues.email;
        this.emailToSend = formValues.email;
      } else {
        console.log(200000000000);
        console.log(this.hasUserList, this.userListType);
        if (this.hasUserList && !this.userListType) {
          this.identifierForServer = formValues.identifier;
          this.emailToSend = formValues.email;
          console.log(300000000000);
        } else {
          if (formValues.email[0] == "@") {
            if (this.ucanss || this.demo || this.levi) {
              this.identifierForServer =
                new Date().valueOf() + formValues.email;
            } else {
              //this.identifierForServer = formValues.identifier + formValues.email;
              this.identifierForServer = formValues.identifier;
            }
            this.emailToSend = this.identifierForServer;
          } else {
            if (this.ucanss || this.demo || this.levi) {
              this.identifierForServer =
                new Date().valueOf() + "@" + formValues.email;
            } else {
              //uncomment this for normal campaigns
              //this.identifierForServer = formValues.identifier + '@' + formValues.email;
              //comment this for normal campaigns
              this.identifierForServer = formValues.identifier;
            }

            this.emailToSend = this.identifierForServer;
            console.log(500000000000);
          }
        }
      }
      this.showLoaderLogin = true;
      this.textError = "";
      this.fadeInConnexion = false;
      this.postAuthenticate(
        this.route.params["_value"].url,
        formValues.name,
        formValues.lastName,
        this.identifierForServer,
        this.emailToSend
      );
    }
  }
  loginPage() {
    console.log(this.route.params["_value"].url);
    this.router.navigate([this.route.params["_value"].url + "/login"]);
  }

  ngOnInit(): void {
    var hash = localStorage.getItem("hash");
    console.log(hash);
    this.baseUrl = apiUrl;
    this.backgroundColor = "#ffffff";
    this.fadeOutLoader = false;
    this.logo = false;
    this.getUrl(this.route.params["_value"].url);
    if (this.route.params["_value"].url == "nocibe") {
      this.nocibe = true;
    }
    if (
      this.route.params["_value"].url == "nexter" ||
      this.route.params["_value"].url == "nexter-egalite"
    ) {
      this.nexter = true;
    } else {
      if (this.route.params["_value"].url === "phoneregie") {
        this.phoneRegie = true;
      } else {
        this.phoneRegie = false;
      }
      if (this.route.params["_value"].url === "oeth") {
        this.oeth = true;
      } else {
        this.oeth = false;
      }

      if (
        this.route.params["_value"].url === "groupeavril" ||
        this.route.params["_value"].url === "seeph2022" ||
        this.route.params["_value"].url === "SEEPH2022" ||
        this.route.params["_value"].url === "PUM" ||
        this.route.params["_value"].url === "pum" ||
        this.route.params["_value"].url === "lavillette" ||
        this.route.params["_value"].url === "asturienne" ||
        this.route.params["_value"].url === "securitesociale" ||
        this.route.params["_value"].url === "symrise" ||
        this.route.params["_value"].url === "securitesociale-a" ||
        this.route.params["_value"].url === "promod" ||
        this.route.params["_value"].url === "calzedonia" ||
        this.route.params["_value"].url === "GEPC" ||
        this.route.params["_value"].url === "gpec" 
      ) {
        this.ucanss = true;
      } else {
        this.ucanss = false;
      }
      if (this.route.params["_value"].url === "demo") {
        this.demo = true;
      } else {
        this.demo = false;
      }
      if (this.route.params["_value"].url === "levi") {
        this.levi = true;
      } else {
        this.levi = false;
      }
      if (
        this.route.params["_value"].url === "moet" ||
        this.route.params["_value"].url === "moet-egalite"
      ) {
        this.moet = true;
      } else {
        this.moet = false;
      }
      if (
        this.route.params["_value"].url === "heineken-egalite" ||
        this.route.params["_value"].url === "heineken-lgbt" ||
        this.route.params["_value"].url === "heineken-handicap"
      ) {
        this.hein = true;
      } else {
        this.hein = false;
      }
    }

    /*if(typeof hash == null){
     this.backgroundColor = '#ffffff';
     this.fadeOutLoader = false;
     this.logo = false;
     this.getUrl(this.route.params['_value'].url);
     }
     else{
     this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+'policy'+'/1'])
     }*/
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/login/login.component.ts